import React from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaMobile } from "react-icons/fa";
import { companyConfig } from "../config/company";
import "./Contact.css";

const Contact: React.FC = () => {
  return (
    <section className="contact">
      <div className="contact-container">
        <h2>Kontaktieren Sie uns</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Unsere Kontaktdaten</h3>
            <div className="info-item">
              <FaPhone />
              <div>
                <h4>Telefon</h4>
                <p>{companyConfig.contact.phone}</p>
              </div>
            </div>
            <div className="info-item">
              <FaMobile />
              <div>
                <h4>Mobile</h4>
                <p>{companyConfig.contact.mobile}</p>
              </div>
            </div>
            <div className="info-item">
              <FaEnvelope />
              <div>
                <h4>E-Mail</h4>
                <p>{companyConfig.contact.email}</p>
              </div>
            </div>
            <div className="info-item">
              <FaMapMarkerAlt />
              <div>
                <h4>Adresse</h4>
                <p>
                  {companyConfig.contact.address.street}
                  <br />
                  {companyConfig.contact.address.zip}{" "}
                  {companyConfig.contact.address.city}
                </p>
              </div>
            </div>
            <div className="business-hours">
              <h4>Geschäftszeiten</h4>
              {companyConfig.businessHours.map((hours, index) => (
                <p key={index}>
                  {hours.day}: {hours.hours}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
